import { useMutation } from 'react-query'
import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { showErrorMessageToast } from 'common/MessageToasts/ErrorMessageToast/ErrorMessageToast'

export interface GenerateCampaignInputsResponse {
  growth_goals_input: string
  key_dates_input: string
}

export const useGenerateCampaignInputs = (brandPlanId: number) => {
  const workspaceId = useCurrentWorkspaceId()

  return useMutation<GenerateCampaignInputsResponse, Error>(
    async () => {
      const response = await sendToApi<GenerateCampaignInputsResponse>(
        `/w/${workspaceId}/brand_plans/${brandPlanId}/generate_campaign_inputs`,
        {
          method: 'POST',
        },
      )
      if (response.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error('Failed to generate campaign inputs')
      }
      return response.data
    },
    {
      onError: (error) => {
        showErrorMessageToast(error.message || 'Failed to generate content. Please try again.')
      },
    },
  )
}
